
    import './styles.scoped.css';
    export default {
  "dialog": "awsui_dialog_1d2i7_1ls09_25",
  "modal-slide-up": "awsui_modal-slide-up_1d2i7_1ls09_1",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_1d2i7_1ls09_1",
  "refresh": "awsui_refresh_1d2i7_1ls09_48",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_1d2i7_1ls09_1",
  "root": "awsui_root_1d2i7_1ls09_81",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_1d2i7_1ls09_1",
  "hide-dismiss-button": "awsui_hide-dismiss-button_1d2i7_1ls09_158",
  "hidden": "awsui_hidden_1d2i7_1ls09_161",
  "focus-lock": "awsui_focus-lock_1d2i7_1ls09_165",
  "position-top": "awsui_position-top_1d2i7_1ls09_173",
  "position-center": "awsui_position-center_1d2i7_1ls09_176",
  "small": "awsui_small_1d2i7_1ls09_190",
  "medium": "awsui_medium_1d2i7_1ls09_193",
  "large": "awsui_large_1d2i7_1ls09_196",
  "x-large": "awsui_x-large_1d2i7_1ls09_199",
  "xx-large": "awsui_xx-large_1d2i7_1ls09_202",
  "custom-width": "awsui_custom-width_1d2i7_1ls09_205",
  "max": "awsui_max_1d2i7_1ls09_208",
  "breakpoint-xs": "awsui_breakpoint-xs_1d2i7_1ls09_208",
  "custom-height": "awsui_custom-height_1d2i7_1ls09_213",
  "container": "awsui_container_1d2i7_1ls09_218",
  "custom-height-container": "awsui_custom-height-container_1d2i7_1ls09_258",
  "content": "awsui_content_1d2i7_1ls09_264",
  "no-paddings": "awsui_no-paddings_1d2i7_1ls09_269",
  "custom-height-content": "awsui_custom-height-content_1d2i7_1ls09_273",
  "header": "awsui_header_1d2i7_1ls09_278",
  "header--text": "awsui_header--text_1d2i7_1ls09_290",
  "footer": "awsui_footer_1d2i7_1ls09_294",
  "footer--rounded": "awsui_footer--rounded_1d2i7_1ls09_303",
  "dismiss-control": "awsui_dismiss-control_1d2i7_1ls09_315",
  "modal-open": "awsui_modal-open_1d2i7_1ls09_319"
};
  